/* eslint-disable no-underscore-dangle */
import http from '@/tool/http/http'

function service() {
  const Services = {}
  Services._getUnits = data => http.POST('/api/units/getUnits', data)
  // 获取全部设岗单位
  Services._getAllunits = () => http.GET('/api/units/all')
  // 获取所有包括已经关闭的审核列表
  Services._getAllunits2 = data => http.GET('/api/units/all2', data)
  // 添加用工单位
  Services._addUnit = data => http.POST('/api/units/addUnit', data)
  // 关闭用工单位
  Services._closeUnit = id => http.POST(`/api/units/close/${id.id}`, id)
  // 获取所有单位
  Services._allUnit = () => http.GET('/api/units/all')
  // 模糊匹配获取用工单位
  Services._queryUnitByName = name => http.GET(`/api/units/dim/query/${name}`)
  // 固定岗位新增有效期
  Services._createValidity = data => http.POST('/api/units/createValidity', data)
  // 根据id,编辑固定岗位有效期名称
  Services._editValidity = data => http.POST(`/api/units/edit/${data.name}/${data.id}/${data.jobTime}`)
  // 根据id,删除固定岗位有效期名称
  Services._deleteValidity = id => http.POST(`/api/units/delete/${id}`)
  // 就业信息查询
  Services._queryEmploymentInformation = snOrName => http.GET(`/api/units/queryEmploymentInformation/${snOrName}`)
  // 批量下岗
  Services._massLaid = id => http.GET(`/api/units/massLaid/${id}`)
  return Services
}
export default service
